import { createFileRoute } from '@tanstack/react-router';

import { SubcontractsOverviewPage } from '@/features/subcontracts/overview-page';

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/overview')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <SubcontractsOverviewPage projectId={projectId} />;
}
